import React, { Fragment } from 'react'
import { Menu, MenuButton, MenuItems, MenuItem, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ProfileOrgSwitcher(props) {
  const { organizations, current_organization } = props
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm text-gray-300 shadow-sm ring-1 ring-inset ring-gray-600 hover:bg-gray-600">
          {current_organization.name}
          <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
        </MenuButton>
      </div>

      <Transition
        as="div"
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-gray-800 shadow-lg ring-1 ring-inset ring-gray-600 focus:outline-none">
          <div className="py-1">
            {organizations.map((organization) => {
              return (
                <MenuItem key={organization.id}>
                  {({ active }) => (
                    <a
                      href={`/profile/switch_org?organization_id=${organization.id}`}
                      className={classNames(
                        active ? 'bg-gray-600' : '',
                        'block px-4 py-2 text-sm text-gray-300'
                      )}
                    >
                      {organization.name}
                    </a>
                  )}
                </MenuItem>
              )
            })}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  )
}
